export const environment = {
  production: true,
  buildId: '3523324999122471',
  configFile: 'config.json',
};
